import React from 'react';
import { Box, Typography, Alert } from '@mui/material';
import { ArchiveRounded } from '@mui/icons-material';
import { useTranslation } from 'react-i18next';

interface EmailFileExtractorFallbackProps {
  moduleName?: string;
}

const EmailFileExtractorPage: React.FC<EmailFileExtractorFallbackProps> = ({ moduleName }) => {
  const { t } = useTranslation();

  return (
    <Box
      sx={{
        width: '100%',
        height: '100%',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        p: 4,
      }}
    >
      <ArchiveRounded sx={{ fontSize: 80, color: 'primary.main', mb: 3 }} />
      <Typography variant="h4" component="h1" gutterBottom>
        {t('sidebar.emailFileExtractor')}
      </Typography>
      <Alert severity="info" sx={{ mt: 2, maxWidth: 600 }}>
        <Typography variant="body1">
          Модуль выгрузки файлов из Email пока недоступен. {moduleName ? `(${moduleName})` : ''}
        </Typography>
      </Alert>
    </Box>
  );
};

export default EmailFileExtractorPage;

